function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M12.336 7.692v-.769H8.481v-.77h3.855v-.768H8.481v-.77h3.855v-.001c0-.262-.021-.518-.063-.768H8.48v-.77h3.593a4.584 4.584 0 0 0-.356-.768H8.481v-.77h2.678A4.62 4.62 0 0 0 7.71 0a4.622 4.622 0 0 0-3.447 1.538H6.94v.77H3.704c-.142.243-.261.5-.356.769h3.591v.77H3.148c-.042.249-.064.505-.064.767v.001H6.94v.77H3.084v.769H6.94v.77H3.084v.768H1.542a.77.77 0 0 0-1.542 0v5.77c0 3.638 2.674 6.663 6.168 7.217v1.629H1.925a.384.384 0 0 0-.383.38v1.546c0 .215.171.381.383.381h11.57c.21 0 .384-.17.384-.38v-1.546a.379.379 0 0 0-.383-.381H9.252v-1.63c3.496-.552 6.169-3.573 6.169-7.216v-5.77a.77.77 0 0 0-1.542 0h-1.543zm1.543.77v5c0 3.186-2.59 5.769-5.783 5.769h-.772c-3.19 0-5.782-2.588-5.782-5.77v-5H13.88zm-1.543.769v3.848c0 2.548-2.076 4.613-4.626 4.613a4.619 4.619 0 0 1-4.626-4.613V9.23h9.252z"
});

var SvgMic = function SvgMic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 25,
    viewBox: "0 0 16 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mic.fda1d2a9.svg";
export { ForwardRef as ReactComponent };